// Render Prop

import React, { Component, memo } from 'react';
import { Redirect } from 'react-router';

import { observer } from 'mobx-react';

import { Label, Input } from 'reactstrap';

import moment from "moment";

import TableWidget from "../../widgets/TableWidget";


class SelectEmail extends Component {
    static displayName = SelectEmail.name;

    constructor(props) {
        super(props);

        this.props.store.getFromApi(["messages"])

        this.state = {
            loading: true,
            selectedEmail: false,
            filterText: ""
        };

        this.props.store.updateBanner("View Messages");

        this.getTableData = this.getTableData.bind(this);

        this.emailSelect = this.emailSelect.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.displayTable = this.displayTable.bind(this);
        this.handleSubmission = this.handleSubmission.bind(this);
    }

    handleSubmission(event) {
        const id = event.target.value;
        this.setState({ selectedEmail: id })
    }


    render() {
        if (this.state.selectedEmail == false) {
            return (
                <React.Fragment>
                    {this.emailSelect()}
                    {this.displayTable()}
                </React.Fragment>
            )
        }
        else {
            return <Redirect push to={"/staff/Message/" + this.state.selectedEmail} />
        }
    }

    async handleFilterChange(event) {
        await this.setState({ filterText: event.target.value });
    }

    emailSelect() {
        const messages = this.props.store.messages.collection;

        return (
            <div className="row">
                <div className="col-12 col-md-6">
                    <Label for="holidaysFilter">Filter By Name</Label>
                    <Input placeHolder="Student Name..." type="text" id="holidaysFilter" value={this.state.filterText} onChange={this.handleFilterChange} />
                </div>
            </div>
        )
    }

    getTableColumns() {
        return (
            [
                {
                    Header: "", accessor: "col1",
                    Cell: (props) => (
                        <button className="btn btn-light" value={props.cell.value} onClick={this.handleSubmission}>
                            View
                        </button>
                    ),
                    props: {
                        colspan: "1", style: { width: "10%", borderBottom: "3px solid white"  }
                    }
                },
                { Header: "To", accessor: "col2", props: { colspan: "1", style: {width: "25%"}} },
                { Header: "From", accessor: "col3", props: { colspan: "1", style: { width: "20%" }} },
                { Header: "Date", accessor: "col4", props: { colspan: "1", style: { width: "25%" } } },
            ]
        );
    }

    getTableData(messages) {
        return messages.map(message => {
            const students = this.props.store.students.collection.filter(student => message.studentIds.includes(student.id))
            let studentNames = students.map(student => student.name);

            let studentNamesDisplay = "";
            if (studentNames.length > 3) {
                const x = studentNames.length - 3;
                studentNamesDisplay = studentNames.slice(0, 3).join(", ") + `, and ${x} more.`
            }
            else {
                studentNamesDisplay = studentNames.join(", ")
            }
    
            return {
                    col1: message.id,
                    col2: studentNamesDisplay,
                    col3: message.senderName,
                    col4: moment(message.createdDate).format("dddd, MMMM Do YYYY, h:mm:ss a")
                }
            }
        )
    }

    displayTable() {
        const columns = this.getTableColumns();

        let messages = this.props.store.messages.collection;

        messages = messages.filter(message => {
            const students = this.props.store.students.collection.filter(student => message.studentIds.includes(student.id))
            let studentNames = students.map(student => student.name).join(" ");

            return studentNames.toLowerCase().includes(this.state.filterText.toLowerCase())
        });


        //Sort employers by name;
        /*employers.sort((employerA, employerB) => {
            const nameA = employerA.name.toLowerCase()
            const nameB = employerB.name.toLowerCase()

            if (nameA > nameB) {
                return 1
            }
            else if (nameA < nameB) {
                return -1
            }
            return 0
        });*/

        const data = this.getTableData(messages).reverse();

        return (
            <TableWidget
                tableProps={{ style: "mt-4" }}
                headerGroupProps={{ }}
                rowProps={{  }}
                columns={columns}
                data={data} />
        )
    }

}



SelectEmail = observer(SelectEmail);


export default  SelectEmail;